var JQuickAdd = (function(module, $) {
    'use strict';

    // Public functions
    var init;

    // Private general variables
    var settings, variantID, firstOptionValue, secondOptionValue, thirdOptionValue, firstOptionPostion, secondOptionPostion, thirdOptionPostion;

    // Private plugin variables
    var $productItem, $productQuickAdd, $productOptions, $productOption, $selectOption, $selectOptionSize, $elementSelectOption, $firstOption, $secondOption, $thirdOption;

    // Private functions
    var addToCart, selectVariant, optionUnavailable, checkOptionOutOfStock, defaultColourSelected, cartItems;


    init = function(options) {
            settings = {
                productItem: '.product-item',
                productQuickAdd: '.product-quick-add',
                productOptions: '.product-options-select',
                selectOption: '.select-option',
                firstOption: '.first-option',
                secondOption: '.second-option',
                thirdOption: '.third-option'
            };

            $productItem = $(settings.productItem);
            $productQuickAdd = $productItem.find(settings.productQuickAdd);
            $productOptions = $productQuickAdd.find(settings.productOptions);
            $selectOption = $productQuickAdd.find(settings.selectOption);
            $elementSelectOption = $selectOption.find('li');

            //Select Variant
            defaultColourSelected();
            selectVariant();
            //optionUnavailable();
        }
        // Has Colour Variant
    defaultColourSelected = function() {

        $.getJSON('/cart.js', function(cart) {
            cartItems = cart.items;
            $productItem.each(function() {
                $productItem = $(this);
                $productQuickAdd = $productItem.find(settings.productQuickAdd);
                $productOptions = $productItem.find(settings.productOptions);
                $firstOption = $productItem.find(settings.firstOption);
                $secondOption = $productItem.find(settings.secondOption);
                $thirdOption = $productItem.find(settings.thirdOption);
                if ($firstOption.hasClass('colour-option')) {
                    $firstOption.find('li').not('.out-of-stock').eq(0).addClass('selected');
                    var $dataFirstOptionValue = $firstOption.find('li.selected').data('value');

                    if ($thirdOption.find('li.selected').data('value') == undefined) {
                        checkOptionOutOfStock($productOptions, cartItems, $secondOption, $dataFirstOptionValue);
                    }
                } else {
                    return;
                }
            });
        });
    }

    selectVariant = function() {
        $elementSelectOption.on('click', function(e) {

            var $this = $(this),
                $thisValue, $thisSelectOption, $thisOptionPosition, $thisOptionIndex, $option, $optionValue, cartItems;

            if ($this.hasClass('selected') || $this.hasClass('out-of-stock') || $this.hasClass('unavailable')) {
                return;
            }

            $productItem = $this.parents(settings.productItem).eq(0);
            $productQuickAdd = $productItem.find(settings.productQuickAdd);
            $productOptions = $productItem.find(settings.productOptions);
            $selectOption = $productItem.find(settings.selectOption);
            $selectOptionSize = $productOptions.data('size');
            $firstOption = $productQuickAdd.find(settings.firstOption);
            $secondOption = $productQuickAdd.find(settings.secondOption);
            $thirdOption = $productQuickAdd.find(settings.thirdOption);

            $thisValue = $this.data('value');
            $thisSelectOption = $this.parents(settings.selectOption).eq(0);
            $thisOptionPosition = $thisSelectOption.data('option');
            $thisOptionIndex = $thisSelectOption.data('index');

            if ($thisSelectOption.hasClass('colour-option')) {
                if($this.index() == 0){
                    $productItem.find('.image').removeClass('swatch');
                    setTimeout(function() {
                        $productItem.find('picture.swatch').remove();
                    }, 120);    
                }else{
                    var image_url = $this.data('image').split('=='),
                        image_first = image_url[0],
                        image_second = image_url[1],
                        image_html = '';
                        image_html += '<picture class="swatch">';
                        image_html += '<source srcset="'+ image_first +' 1x, '+ image_second +' 2x">';
                        image_html += '<img loading="lazy" importance="low" src="'+ image_first +'" alt="" itemprop="image" />';
                        image_html += '</picture>';
                    $productItem.find('.image').addClass('swatch').append(image_html);
                }
                $this.addClass('selected');
                $thisSelectOption.find('li').not($this).removeClass('selected');
                var $dataFirstOptionValue = $thisSelectOption.find('li.selected').data('value');
                if ($thirdOption.find('li.selected').data('value') == undefined) {
                    $secondOption.find('li').removeClass('out-of-stock');
                    var cartItems;
                    $.getJSON('/cart.js', function(cart) {
                        cartItems = cart.items;
                        checkOptionOutOfStock($productOptions, cartItems, $secondOption, $dataFirstOptionValue);
                    });

                }
            } else {
                firstOptionValue = $firstOption.find('li.selected').data('value');
                firstOptionPostion = $firstOption.data('option');
                switch ($thisOptionIndex) {
                    case 1:
                        firstOptionValue = $thisValue;
                        firstOptionPostion = $thisOptionPosition;
                        break;
                    case 2:
                        secondOptionValue = $thisValue;
                        secondOptionPostion = $thisOptionPosition;
                        break;
                    case 3:
                        thirdOptionValue = $thisValue;
                        thirdOptionPostion = $thisOptionPosition;
                        break;
                }
                if ($selectOptionSize == $thisOptionIndex) {
                    switch ($selectOptionSize) {
                        case 1:
                            $productOption = $productOptions.find('option[data-' + firstOptionPostion + '="' + firstOptionValue + '"]');
                            $option = $firstOption;
                            $optionValue = firstOptionValue;
                            variantID = $productOption.val();
                            break;
                        case 2:
                            $productOption = $productOptions.find('option[data-' + firstOptionPostion + '="' + firstOptionValue + '"][data-' + secondOptionPostion + '="' + secondOptionValue + '"]');
                            $option = $secondOption;
                            $optionValue = secondOptionValue;
                            variantID = $productOption.val();
                            break;
                        case 3:
                            $productOption = $productOptions.find('option[data-' + firstOptionPostion + '="' + firstOptionValue + '"][data-' + secondOptionPostion + '="' + secondOptionValue + '"][data-' + thirdOptionPostion + '="' + thirdOptionValue + '"]');
                            $option = $thirdOption;
                            $optionValue = thirdOptionValue;
                            variantID = $productOption.val();
                            break;
                    }
                    // Add to Cart
                    addToCart($productItem, variantID);
                } else {
                    optionUnavailable($this, firstOptionValue, secondOptionValue, thirdOptionValue);
                    $this.addClass('selected');
                    $thisSelectOption.hide().next().show();
                }
            }

        });
    }

    optionUnavailable = function($this, firstOptionValue, secondOptionValue, thirdOptionValue) {
        var $firstOption, $secondOptioconsole;
        if ($this) {
            $productItem = $this.parents(settings.productItem).eq(0);
            $productQuickAdd = $productItem.find(settings.productQuickAdd);
            $productOptions = $productQuickAdd.find(settings.productOptions);
            $selectOption = $productQuickAdd.find(settings.selectOption);
            $elementSelectOption = $selectOption.find('li');

            //First Option
            if ($productQuickAdd.find(settings.firstOption).length > 0) {
                $firstOption = $productQuickAdd.find(settings.firstOption);
                firstOptionPostion = $firstOption.data('option');
            }
            //Second Option
            if ($productQuickAdd.find(settings.secondOption).length > 0) {
                $secondOption = $productQuickAdd.find(settings.secondOption);
                secondOptionPostion = $secondOption.data('option');
            }
            //Third Option
            if ($productQuickAdd.find(settings.thirdOption).length > 0) {
                $thirdOption = $productQuickAdd.find(settings.thirdOption);
                thirdOptionPostion = $thirdOption.data('option');
            }

            //Out of Stock 
            if ($firstOption != undefined) {
                if (firstOptionValue != null) {
                    $elementSelectOption.removeClass('selected out-of-stock unavailable');
                    if ($thirdOption == undefined) {
                        // Two Options
                        if ($secondOption != undefined) {
                            var $secondOptionValues = [],
                                $secondOptionAvailableValues = [],
                                $secondOptionUnavailableValues = [];

                            $secondOption.find('li').removeClass('selected out-of-stock unavailable').each(function() {
                                $secondOptionValues.push($(this).data('value'));
                            });

                            $productOptions.find('option').each(function() {
                                $dataFirstOptionValue = $(this).data(firstOptionPostion);
                                $dataSecondOptionValue = $(this).data(secondOptionPostion);
                                $dataInventoryQuantity = parseInt($(this).data('inventory_quantity'));

                                if ($dataFirstOptionValue == firstOptionValue) {
                                    $secondOptionAvailableValues.push($dataSecondOptionValue);
                                    if ($dataInventoryQuantity < 1) {
                                        $optionOutOfStock = $dataSecondOptionValue;
                                        $secondOption.find('li').each(function() {
                                            if ($(this).data('value') == $optionOutOfStock) {
                                                $(this).addClass('out-of-stock');
                                            }
                                        });
                                    }
                                    checkOptionOutOfStock($(this), $secondOption, $dataSecondOptionValue);
                                }
                            });

                            $secondOptionUnavailableValues = array_diff($secondOptionValues, $secondOptionAvailableValues);
                            if ($secondOptionUnavailableValues.length > 0) {
                                $secondOptionUnavailableValues.forEach(function(unavailableValue, index) {
                                    $secondOption.find('li').each(function() {
                                        if ($(this).data('value') == unavailableValue) {
                                            $(this).addClass('unavailable');
                                        }
                                    });
                                });
                            }
                        }
                    } else {
                        // Three Options
                        var $thirdOptionValues = [],
                            $thirdOptionAvailableValues = [],
                            $thirdOptionUnavailableValues = [];

                        $thirdOption.find('li').removeClass('selected out-of-stock unavailable').each(function() {
                            $thirdOptionValues.push($(this).data('value'));
                        });
                        $productOptions.find('option').each(function() {
                            $dataFirstOptionValue = $(this).data(firstOptionPostion);
                            $dataSecondOptionValue = $(this).data(secondOptionPostion);
                            $dataThirdOptionValue = $(this).data(thirdOptionPostion);
                            $dataInventoryQuantity = parseInt($(this).data('inventory_quantity'));

                            if ($dataFirstOptionValue == firstOptionValue && $dataSecondOptionValue == secondOptionValue) {
                                $thirdOptionAvailableValues.push($dataThirdOptionValue);
                                if ($dataInventoryQuantity < 1) {
                                    $optionOutOfStock = $dataThirdOptionValue;
                                    $thirdOption.find('li').each(function() {
                                        if ($(this).data('value') == $optionOutOfStock) {
                                            $(this).addClass('out-of-stock');
                                        }
                                    });
                                }
                                checkOptionOutOfStock($(this), $thirdOption, $dataThirdOptionValue);
                            }
                        });

                        $thirdOptionUnavailableValues = array_diff($thirdOptionValues, $thirdOptionAvailableValues);
                        if ($thirdOptionUnavailableValues.length > 0) {
                            $thirdOptionUnavailableValues.forEach(function(unavailableValue, index) {
                                $thirdOption.find('li').each(function() {
                                    if ($(this).data('value') == unavailableValue) {
                                        $(this).addClass('unavailable');
                                    }
                                });
                            });
                        }
                    }
                }
            }
        } else {
            // One Option
            $productItem.each(function() {
                $productItem = $(this);
                $productQuickAdd = $productItem.find(settings.productQuickAdd);
                $productOptions = $productItem.find(settings.productOptions);
                $selectOption = $productItem.find(settings.selectOption);
                $selectOptionSize = $selectOption.size();
                $firstOption = $productItem.find(settings.firstOption);
                firstOptionPostion = $firstOption.data('option');

                //Out of stock
                if ($selectOptionSize == 1 && $firstOption != undefined) {
                    $firstOption.find('li').removeClass('selected out-of-stock unavailable');

                    $productOptions.find('option').each(function() {
                        $dataVariantID = $(this).val();
                        $dataFirstOptionValue = $(this).data(firstOptionPostion);
                        $dataInventoryQuantity = parseInt($(this).data('inventory_quantity'));

                        if ($dataInventoryQuantity < 1) {
                            $optionOutOfStock = $dataFirstOptionValue;
                            $firstOption.find('li').each(function() {
                                if ($(this).data('value') == $optionOutOfStock) {
                                    $(this).addClass('out-of-stock');
                                }
                            });
                        }
                        checkOptionOutOfStock($(this), $firstOption, $dataFirstOptionValue);
                    });
                }
                if ($firstOption.hasClass('colour-option')) {

                }
            });
        }
    };
    /*
    checkOptionOutOfStock = function($productOption, $option, $optionValue) {
        var $dataVariantID, $dataInventoryQuantity, $optionOutOfStock;

        $dataVariantID = $productOption.val();
        $dataInventoryQuantity = parseInt($productOption.find(':selected').data('inventory_quantity'));
        // console.log($dataInventoryQuantity);
        // console.log($dataVariantID);
        $.getJSON('/cart.js', function(cart) {
            jQuery.each(cart.items, function(index, item) {
                if (item.id == $dataVariantID) {
                    $dataInventoryQuantity = $dataInventoryQuantity - parseInt(item.quantity);
                    if ($dataInventoryQuantity < 1) {
                        $optionOutOfStock = $optionValue;
                        $option.find('li').each(function() {
                            if ($(this).data('value') == $optionOutOfStock) {
                                $(this).addClass('out-of-stock');
                            }
                        });
                    }
                }
            })
        });
    };
*/
    checkOptionOutOfStock = function($productOption, cartItems, $option, $dataFirstOptionValue) {
        var $dataInventoryQuantity, $optionOutOfStock;

        $productOption.find('option').each(function() {
            var $thisOption = $(this);
            $dataInventoryQuantity = $thisOption.data('inventory_quantity');

            if ($dataFirstOptionValue == $thisOption.data('option1')) {

                jQuery.each(cartItems, function(index, cartItem) {
                    if (cartItem.id == $thisOption.val()) {
                        $dataInventoryQuantity = $dataInventoryQuantity - parseInt(cartItem.quantity);
                    }
                });

                if ($dataInventoryQuantity < 1) {
                    $optionOutOfStock = $thisOption.data('option2');
                    // console.log($dataFirstOptionValue);
                    // console.log($dataInventoryQuantity);
                    // console.log($optionOutOfStock);
                    $option.find('li').each(function() {
                        //$(this).removeClass('out-of-stock');
                        if ($(this).data('value') == $optionOutOfStock) {
                            $(this).addClass('out-of-stock');
                        }
                    });
                }
            }

        });
    };

    addToCart = function($product, variantID) {
        $.post('/cart/add.js', { quantity: 1, id: variantID }, null, 'json').done(function(data) {
            ajaxCart.load();
            $product.addClass('hover').find(settings.selectOption).removeAttr('style').delay(3600).queue(function(rvt) {
                $product.removeClass('hover');
            })
            $product.find('.product-options').append('<span class="message">Added to bag</span>').delay(3650).queue(function(rvt) {
                $product.find('.message').remove();
                rvt();
            });
        }).fail(function(data) {
            var error = data.status;
            if (data.status == 422) {
                error = 'Sorry, Sold Out';
            }
            if (data.status == 400) {
                error = 'Sorry, Unavailable';

            }
            $product.addClass('hover').find(settings.selectOption).removeAttr('style').delay(3600).queue(function(rvt) {
                $product.removeClass('hover');
            })
            $product.find('.product-options').append('<span class="message">' + error + '</span>').delay(3650).queue(function(rvt) {
                $product.find('.message').remove();
                rvt();
            });
        });
    }

    module = {
        init: init
    };

    return module;

}(JQuickAdd || {}, jQuery));

jQuery(document).ready(function() {
    JQuickAdd.init();
    if (jQuery('.grid-1.hero-banner .owl-carousel').length) {
        jQuery('.grid-1.hero-banner .owl-carousel').owlCarousel({
            loop: true,
            autoplay: false,
            nav: true,
            dots: true,
            items: 1,
            navText: ['<span class="icon"><i class="bx bx-chevron-left"></i></span>', '<span class="icon"><i class="bx bx-chevron-right"></i></span>'],
        });
    }
});